import React, {Component} from 'react';
import {connect} from 'react-redux';
import Step from '../parts/Step';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {Maybe} from '../../utils/logging';
import _ from 'lodash';
import {setLanguageIndex, metricConversion} from '../../utils/helpers';
import * as actions from '../../actions';

class KrwContent extends  Component {

    /**
     * handleStepName
     * @param number
     * @param names
     * @returns {string}
     */
    handleStepName(number, names) {
        const step = 'step';
        return `${step}${names[number]}`;
    }

    calculateSize(type) {
        const getValue = (field) => {
            return Maybe.of(field)
                .map((field) => {
                    return parseFloat(field.CurrentValue);
                })._value || 0;
        }
        if (type === 'lange') {
            return (parseInt(getValue(this.props.krw.W_LAENGE)));
        }
        if (type === 'breite') {
            return (parseInt(getValue(this.props.krw.W_BREITE)));
        }
    }

    updateContent(stepName, index, arr) {
        const details = [];
        switch(stepName) {

            case 'One':
                details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.2`)} ${this.calculateSize('lange')} mm x ${this.calculateSize('breite')} mm`);
                break;
            case 'Two':
                const SIK = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue);
                        })
                        .map((field_value) => {
                            details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.1`)} S${this.props.krw.SIK.CurrentValue}`);
                        })
                };
                SIK(this.props.krw.SIK);

                const SICHTKANTE = (field) => {
                    return Maybe.of(this.props.krw[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value === '0') {
                                Maybe.of(this.props.krw[`${field}_switch`])
                                    .map((zswitch) => {
                                        return zswitch.CurrentValue;
                                    })
                                    .map((zswitch_value) => {
                                        if(zswitch_value !== '0') {
                                            details.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.summary.${field}.${zswitch_value}`));
                                        }
                                    });
                            }
                        })
                };

                ['SK23', 'SK45', 'SK67', 'SK81'].forEach((field) => {
                    SICHTKANTE(field);
                });
                break;

            case 'Three':
                const SOCKET = (field) => {
                    let socket, choice, measure;
                    return Maybe.of(this.props.krw[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value !== '0' && field_value !== '00') {
                                socket = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${field}`);
                                choice = this.props.krw[field].Values.Value.find(((el) => {return parseInt(el.Code) === parseInt(field_value)})).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                                measure = `(${this.props.krw[field.concat('X')].CurrentValue} mm, ${this.props.krw[field.concat('Y')].CurrentValue} mm)`;
                                details.push(`${socket}: ${measure}`);
                            }
                        })
                };

                ['ST1', 'ST2', 'ST3', 'ST4', 'ST5'].forEach((field) => {
                    SOCKET(field);
                });
                break;

            case 'Four':
                const CUTOUT = (field) => {
                    let cutout, measure;
                    return Maybe.of(this.props.krw[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value !== '0' && field_value !== '00') {
                                cutout = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${field}`);
                                measure = `${this.props.krw[field.concat('X')].CurrentValue} mm x ${this.props.krw[field.concat('Y')].CurrentValue} mm (${this.props.krw[field.concat('PX')].CurrentValue} mm, ${this.props.krw[field.concat('PY')].CurrentValue} mm)`;
                                details.push(`${cutout}: ${measure}`);
                            }
                        })
                };

                ['AS1', 'AS2', 'AS3', 'AS4', 'AS5'].forEach((field) => {
                    CUTOUT(field);
                });
                break;

            case 'Five':
                const CUTOUTROUND = (field) => {
                    let cutout, measure;
                    return Maybe.of(this.props.krw[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value !== '0' && field_value !== '00') {
                                cutout = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${field}`);
                                measure = `ø ${this.props.krw[field.concat('D')].CurrentValue} mm (${this.props.krw[field.concat('PX')].CurrentValue}, ${this.props.krw[field.concat('PY')].CurrentValue})`;
                                details.push(`${cutout}: ${measure}`);
                            }
                        })
                };

                ['ASR1', 'ASR2', 'ASR3', 'ASR4', 'ASR5'].forEach((field) => {
                    CUTOUTROUND(field);
                });

                break;

            case 'Six':
                const SIDEFLANGE = (field) => {
                    let sideflange, measure;
                    return Maybe.of(this.props.krw[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value !== '0' && field_value !== '00') {
                                sideflange = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${field}`);
                                measure = this.props.krw[field.replace(/GK/g, "GKM")].CurrentValue;
                                details.push(`${sideflange}: ${measure} mm`);
                            }
                        })
                };

                ['GK45', 'GK81'].forEach((field) => {
                    SIDEFLANGE(field);
                });

                break;

            case 'Seven':
                const checkboxContent = [];
                const FA = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue)
                        })
                        .map((fa_value) => {
                            details.push(this.props.krw.FA.Values.Value.find((el) => { return  parseInt(el.Code) === fa_value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`]);
                        })
                }

                const GLASSUR = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue);
                        })
                        .map((glassur_value) => {
                            checkboxContent.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.OV`));
                        })
                }

                FA(this.props.krw.FA);
                GLASSUR(this.props.krw.OV)
                details.push(checkboxContent.join(', '));

                break;
            default:
                return details;
        }
        return details;
    }


    render() {
        let name, value = '';
        return this.props.list.map((el, index, arr) => {
            if(!el){return}
            let details = [];
            if (index === arr.length - 1) {
                name = 'downloadAndContact.title';
            } else {
                name = `${this.props.field}.${this.handleStepName(index, arr)}.menu.title`;
                details = this.updateContent(el, index, arr);
            }
            return (
                <Step
                    key={index}
                    name={this.props.translate(name)}
                    value={value}
                    details={details}
                    currentStep={this.props.currentStep}
                    stepNo={index + 1} />

            );
        });
    }

}

function mapStateToProps({krw, locale}) {
    return {
        translate:      getTranslate(locale),
        currentLanguge: getActiveLanguage(locale).code,
        krw,
    }
}

export default connect(mapStateToProps, actions)(KrwContent);



// WEBPACK FOOTER //
// ./src/components/sidebar-menu/KrwContent.js